import { useMemo } from 'react';
import { AddressType } from '@api';
import { getCountriesList } from '../../utils';
import {
  getAddressMultiLineString,
  getAddressSingleLineString,
  getCountryLabel,
} from './helpers';

type FormatAddressReturnType = {
  formatAddressMultiLine: (addressData: AddressType) => string | undefined;
  formatAddressSingleLine: (addressData: AddressType) => string | undefined;
};

export const useFormatAddress = (): FormatAddressReturnType => {
  const countriesList = useMemo(() => getCountriesList(), []);

  const formatAddressMultiLine = (addressData: AddressType) => {
    const { country, ...address } = addressData;
    const countryLabel = getCountryLabel(countriesList, country);

    const addressString = getAddressMultiLineString({
      ...address,
      country: countryLabel,
    });

    return addressString;
  };

  const formatAddressSingleLine = (addressData: AddressType) => {
    const { country, ...address } = addressData;
    const countryLabel = getCountryLabel(countriesList, country);
    return getAddressSingleLineString({
      ...address,
      country: countryLabel,
    });
  };

  return { formatAddressMultiLine, formatAddressSingleLine };
};
